import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Image from "next/image";
import styles from "@/styles/BlurImageBackground.module.scss";
import classnames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function BlurImageBackground(_ref) {
  var _classnames;

  var item = _ref.item,
      children = _ref.children,
      className = _ref.className,
      _ref$imageOptions = _ref.imageOptions,
      imageOptions = _ref$imageOptions === void 0 ? {} : _ref$imageOptions;
  var url = item.thumbnailUrl;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(styles.container, (_classnames = {}, _defineProperty(_classnames, styles.carousel, className === "carousel"), _defineProperty(_classnames, styles.title, className === "title"), _classnames)),
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.background,
      children: /*#__PURE__*/_jsx("figure", {
        children: /*#__PURE__*/_jsx(Image, _objectSpread({
          src: url,
          alt: item.name,
          layout: "fill",
          objectFit: "cover",
          objectPosition: "50% 50%"
        }, imageOptions))
      })
    }), children]
  });
}